/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { LocationsSummaryResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class LocationsSummaries<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetLocationsSummary
   * @request GET:/locations-summaries
   * @secure
   */
  getLocationsSummary = (params: RequestParams = {}) =>
    this.request<LocationsSummaryResponse, any>({
      path: `/locations-summaries`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsLocationsSummaries
   * @request OPTIONS:/locations-summaries
   */
  optionsLocationsSummaries = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/locations-summaries`,
      method: 'OPTIONS',
      ...params,
    });
}
